const BASKET = "basket/";

export const UPDATE_SELECT_SEATS = BASKET + "updateSelectSeats";
export const UPDATE_BASKET_LENGTH = BASKET + "updateBasketLength";
export const UPDATE_CALENDAR_SALE_QNT_STATE = BASKET + "updateCalendarSaleQntState";